module.exports = __webpack_public_path__ + "static/media/peronizador.2b9a813c.png";


//////////////////
// WEBPACK FOOTER
// ./src/peronizador.png
// module id = 32
// module chunks = 0